<template>
  <div>
    File not found.
  </div>
</template>

<script>
export default {
  name: "404"
}
</script>

<style scoped>
div{
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/pages/blank.vue